import React from "react";
import "./Breadcrumb.scss";
import { Link } from "gatsby";
import { Location } from "@/interfaces/Location";
export type BreadcrumbProps = {
  className?: string;
  location: Location;
  invertColor?: boolean;
};
function replacer(value: string) {
  const replaceMap = {
    cdmx: "CDMX",
    edomex: "EDOMEX",
    mexico: "México",
    une: "UNE",
    amis: "AMIS",
    ine: "INE",
    ife: "IFE",
  };
  const keyWords = Object.keys(replaceMap) as (keyof typeof replaceMap)[];
  let key = keyWords[0];
  if (
    keyWords.some((k) => {
      key = k;
      return value.includes(k);
    })
  ) {
    return value.replaceAll(key, replaceMap[key]);
  }
  return value;
}
function capitalizeFirst(value: string) {
  if (!!!value) return value;
  return value.at(0)?.toUpperCase() + value.slice(1);
}
export const Breadcrumb = ({
  className,
  location,
  invertColor,
}: BreadcrumbProps) => {
  const paths = location.pathname
    .replace("blog/", "")
    .split("/")
    .filter((p) => !!!!p);
  const pathsLength = paths.length;
  return (
    <ul className={`momento-breadcrum${invertColor?" invertColor":""}${!!!className ? "" : ` ${className}`}`}>
      <li>
        <Link to="/">Blog</Link>
      </li>
      {paths.map((p, i) => {
        const title = replacer(capitalizeFirst(p.replaceAll("-", " ")));
        return (
          <li key={p}>
            {pathsLength == i + 1 ? (
              <p>{title}</p>
            ) : (
              <Link to={"#"}>{title}</Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};
